import React from 'react';
import { useQuery } from 'react-query';
import { useAuth } from '../../../context/AuthContext';
import { participantApi } from '../../../api/participant';
import Loader from '../../../components/loader/Loader';

const Profile = () => {
    const { user } = useAuth();
    const { data, isLoading } = useQuery(["participant-profile-page"], participantApi.getProfile, {
        staleTime: 60000,
    });

    const profile = data?.data || data || {};
    const displayName = profile?.name || user?.name || "Participant";
    const email = profile?.email || user?.user?.email || "-";
    const mobilePhone = profile?.phoneNumber || "-";
    const officeLocation = profile?.location || "-";
    const department = profile?.department || "-";
    const jobTitle = profile?.jobTitle || "-";
    
    return (
        <div className="w-full">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">My Profile</h1>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="space-y-4">
                    <p className="text-gray-600">Manage your account details and preferences.</p>
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <div className="mt-4 p-4 bg-gray-50 rounded-md border text-sm grid grid-cols-1 md:grid-cols-2 gap-3">
                            <p><strong>Name:</strong> {displayName}</p>
                            <p><strong>Email:</strong> {email}</p>
                            <p><strong>Department:</strong> {department}</p>
                            <p><strong>Job Title:</strong> {jobTitle}</p>
                            <p><strong>Phone:</strong> {mobilePhone}</p>
                            <p><strong>Location:</strong> {officeLocation}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Profile;
